import { useQuery } from '@tanstack/react-query';
import useLocalStorage from './useLocalStorage';
import { Pose } from '../models';
import QueryKeys from '../utils/QueryKeys';
import { recordPosePayloadCheck } from '../utils/accessFlagTelemetry';

export default function usePoses(studentId, packageId, pastImages = false) {
  const [currentSeason] = useLocalStorage(`currentSeason-${studentId}`);

  return useQuery([QueryKeys.STUDENT_IMAGES, studentId, packageId, false, currentSeason, 'singleSeason'], () => {
    return Pose
      .selectExtra(['folder'])
      .where({ forPackage: [packageId, studentId] })
      .per(999)
      .all()
      .then((res) => {
        if (!res.data) return [];

        // #4641 telemetry: does the client access flag agree with what the
        // server just authorized? Measurement only.
        recordPosePayloadCheck(res.data);
        return res.data;
      });
  }, { placeholderData: [], enabled: !!(studentId && packageId) });
}
